// turn array of data into object mapped by id for O(1) look up
export const objectfyArray = (array) => {
  let object = {};

  array.forEach((a) => {
    object[a.id] = a;
  });

  return object;
};
